import { BaseDocument } from '@dato-proxy/entities/basedocument.entity';
import { SystemOptionView } from '@dato-proxy/views/systemoption.view';

export class GlobalsClass {
    SystemOption: SystemOptionView;
    IsActiveUser: boolean;
    PaymentDocuments: BaseDocument[];

    IsAllowAccounting() {
        if (!this.SystemOption) { return false; }

        return this.SystemOption.IsAllowLedger || this.SystemOption.IsAllowInvoices || this.SystemOption.IsAllowAgingReport || this.SystemOption.IsAllowDeliveries;
    }
}

export let Globals = new GlobalsClass();
